module.exports = __webpack_public_path__ + "img/fin_08_衣袋种子.c34dc40e.jpg";